(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider'];

    function stateConfig($stateProvider, $stickyStateProvider) {
        $stateProvider
            .state('purchase', {
                parent: 'app',
                url: '/purchase',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN'],
                    pageTitle: 'ccsTrApp.contract.purchase.title',
                    title: 'Purchases'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/contract/contracts.html',
                        controller: 'ContractController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchase.all', {
                parent: 'app',
                url: '/contract/purchase/all',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN', 'ROLE_AGENT'],
                    pageTitle: 'ccsTrApp.contract.purchase.title',
                    title: 'Purchases'
                },
                views: {
                    'contract-purchase-all@': {
                        templateUrl: 'app/entities/contract/contracts.html',
                        controller: 'ContractController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchase.purchase-detail', {
                parent: 'app',
                url: '/contract/purchase/{id}/detail',
                sticky: false,
                views: {
                    'contract-purchase-detail@': {
                        controller: 'ContractDetailController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/contract-detail.html'
                    }
                },
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN', 'ROLE_AGENT'],
                    pageTitle: 'ccsTrApp.contract.detail.purchase',
                    title: 'Detail'
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', '$state', 'ContractDTO', function ($stateParams, $state, ContractDTO) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return ContractDTO.get({id : paramId}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'purchase',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('purchase.new', {
                parent: 'app',
                url: '/contract/purchase/new?subCategory',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'ccsTrApp.contract.purchase.create',
                    title: 'New'
                },
                views: {
                    'contract-purchase-new@': {
                        controller: 'ContractDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/contract-dialog.html'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        }
                    },
                    contractPage: function() {
                        return true
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('port');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('compType');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('location');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('pricing');
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        $translatePartialLoader.addPart('comment');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: null,
                            modifiedOn: new Date(),
                            modifiedBy: null,
                            contractType: "PURCHASE",
                            status: "DRAFT",
                            contractDate: new Date(),
                            contractNum: null,
                            category: null,
                            commodity: "COTTON",
                            buyerRef: null,
                            sellerRef: null,
                            thirdPartyRef: null,
                            thirdPartyType: null,
                            priceModel: 'FIXED',
                            priceDisplay: null,
                            fixedPrice: null,
                            priceType: 'CTS',
                            unitType: 'LB',
                            priceValue: null,
                            quantity: null,
                            qtyUnitType: 'BALES',
                            qtyBales: null,
                            qtyMts: null,
                            qtyLbs: null,
                            qtyKgs: null,
                            qtyDisplay: null,
                            tolerance: null,
                            tolType: null,
                            deliveryType: null,
                            deliveryDisplay: null,
                            cropYear: null,
                            growth: null,
                            growthDisplay: null,
                            origin: null,
                            originDisplay: null,
                            wtBasis: null,
                            wtBasisDisplay: null,
                            strength: null,
                            strengthRange: null,
                            range: null,
                            mic: null,
                            stapleDescription: null,
                            gradeDescription: null,
                            stapleGreenCard: null,
                            gradeGreenCard: null,
                            leafGreenCard: null,
                            unf: null,
                            length: null,
                            gradeDescriptionDisplay: null,
                            gradeGreenCardDisplay: null,
                            stapleDescriptionDisplay: null,
                            stapleGreenCardDisplay: null,
                            micDisplay: null,
                            strengthDisplay: null,
                            strengthRangeDisplay: null,
                            rangeDisplay: null,
                            leafGreenCardDisplay: null,
                            qualityDisplay: null,
                            lengthDisplay: null,
                            unfDisplay: null,
                            incoTerms: null,
                            incoTermsDisplay: null,
                            loadingPortDisplay: null,
                            destinationPortDisplay: null,
                            shipmentPeriods: null,
                            paymentType: null,
                            paymentTypeDisplay: null,
                            paymentTerms: null,
                            paymentTermsDisplay: null,
                            otherTerms: null,
                            otherTermsDisplay: null,
                            requiredDocsDisplay: null,
                            specialClauses: null,
                            id: null,
                            quality: 'DESCRIPTION'
                        };
                    }
                }
            })
            .state('purchase.edit', {
                parent: 'app',
                url: '/contract/purchase/{id}/edit',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'ccsTrApp.contract.purchase.edit',
                    title: 'Edit'
                },
                views: {
                    'contract-purchase-edit@': {
                        controller: 'ContractDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/contract-dialog.html'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        }
                    },
                    contractPage: function() {
                        return true
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('port');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('compType');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('location');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('pricing');
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        $translatePartialLoader.addPart('comment');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Contract', function ($stateParams, Contract) {
                        return Contract.get({id: $stateParams.id}).$promise;
                    }],
                    entityAudit: ['$stateParams', 'ContractAudit', function ($stateParams, ContractAudit) {
                        return ContractAudit.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('purchase.fixation-form', {
                parent: 'app',
                url: '/contract/purchase/fixation?contractId',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI']
                },
                views: {
                    'contract-purchase-fixation-form@': {
                        controller: 'FixationDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/fixation/fixation-dialog.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('compType');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        return $translate.refresh();
                    }],
                    selectedContract: ['$stateParams', 'Contract', function ($stateParams, Contract) {
                        return Contract.get({id: $stateParams.contractId}).$promise;
                    }],
                    entity: ['$stateParams', function ($stateParams) {
                        return {};
                    }]
                }
            }).state('purchase.booked-contracts', {
                parent: 'app',
                url: '/contract/booked',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'Booked Contracts',
                    title: 'Booked Contracts'
                },
                views: {
                    'booked-contracts@': {
                        controller: 'ContractBookedController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/contract-booked.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        return $translate.refresh();
                    }]
                }
            }).state('purchase.existing-contracts', {
                parent: 'app',
                url: '/contract/existing',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'Existing Contracts',
                    title: 'Existing Contracts'
                },
                views: {
                    'existing-contracts@': {
                        controller: 'ContractExistingController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/contract-existing.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        return $translate.refresh();
                    }]
                }
            }).state('purchase.gross-estimate', {
                parent: 'app',
                url: '/contract/gross-estimate',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'Contract Gross Estimate',
                    title: 'Contract Gross Estimate'
                },
                views: {
                    'gross-estimate@': {
                        controller: 'ContractGrossEstimateController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/contract-gross-estimate.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        return $translate.refresh();
                    }]
                }
            });

        $stickyStateProvider.enableDebug(true);
    }
})();
